module.exports = __webpack_public_path__ + "static/wire-91ec5739c419df058062624a992970eb.svg";